<table #tableElement class="ds-w-full ds-h-full ds-text-[11px]">
  <thead>
    <tr class="ds-grid ds-grid-flow-col ds-auto-cols-fr ds-grid-cols-[auto]">
      <th
        class="ds-pr-xs ds-mr-2xs md:ds-mr-xs ds-font-regular"
        [style.width]="width"
      ></th>
      <th
        scope="col"
        [attr.data-label]="label"
        *ngFor="let label of labels"
        class="
          ds-flex
          ds-justify-start
          ds-items-center
          ds-font-regular
          ds-pt-xs
          ds-border-t
          ds-border-tertiary-lightgrey
          ds-mb-2xs
          md:ds-mb-xs
          ds-rotate-180
          [writing-mode:vertical-rl]
        "
      >
        {{ label }}
      </th>
    </tr>
  </thead>
  <tbody #bodyElement class="ds-block ds-overflow-y-scroll">
    <tr
      *ngFor="let heatmapSectionDirective of heatmapSectionDirectives"
      class="ds-grid ds-grid-flow-col ds-auto-cols-fr ds-grid-cols-[auto]"
    >
      <th
        scope="row"
        [attr.data-label]="heatmapSectionDirective.label"
        [style.width]="width"
        class="
          ds-flex
          ds-overflow-hidden
          ds-justify-end
          ds-items-center
          ds-font-regular
          ds-pr-xs
          ds-border-r
          ds-border-tertiary-lightgrey
          ds-mr-2xs
          md:ds-mr-xs
        "
      >
        {{ heatmapSectionDirective.label }}
      </th>
      <td
        *ngFor="
          let heatmapPlotDirective of heatmapSectionDirective.heatmapPlotDirectives;
          let index = index
        "
        [class.outline]="heatmapPlotDirective.outline"
        [style.background-color]="heatmapPlotDirective.color"
        [style.grid-column]="index + 2"
        (mouseover)="activeValue = heatmapPlotDirective.data"
        (mouseleave)="activeValue = null"
        class="
          ds-flex ds-justify-center ds-items-center ds-aspect-square
          hover:ds-border-none
          hover:ds-outline
          hover:ds-outline-primary-white
          hover:ds-z-10
          hover:ds-outline-4
        "
      ></td>
    </tr>
  </tbody>
  <caption
    class="[caption-side:bottom] ds-text-right"
    [style.padding-left]="width"
    [style.margin-top]="
      bodyElement.clientHeight / heatmapSectionDirectives.length + 'px'
    "
  >
    <meter
      class="ds-w-full sm:ds-w-5xl"
      [style.height]="
        bodyElement.clientHeight / heatmapSectionDirectives.length + 'px'
      "
      [style.background]="gradient"
      [min]="lowValue"
      [max]="highValue"
      [attr.value]="activeValue"
    ></meter>
    <br />
    <div
      class="
        ds-w-full
        sm:ds-w-5xl
        ds-bg-primary-white ds-pt-2xs ds-inline-grid ds-grid-cols-3
      "
    >
      <div class="ds-text-left">{{ lowValue }} {{ unit }}</div>
      <div class="ds-text-center">
        {{ activeValue }} {{ activeValue !== null ? unit : "" }}
      </div>
      <div class="ds-text-right">{{ highValue }} {{ unit }}</div>
    </div>
  </caption>
</table>
